import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { Modal } from "react-bootstrap";
import { watchHitPayPayment } from "../../utils/hitpayPaymentStatus";
import ModalCloseButton from "../ModalCloseButton/ModalCloseButton";
import "./PaymentMethod.css";

// Shows the HitPay PayNow QR inside a popup. `checkout` is the normalised object from
// readHitPayResponse: { qrImage, url, amount }. Falls back to the hosted page in a frame
// when the API only returns a checkout URL.
const HitPayQrModal = ({ show, onClose, onPaid, checkout }) => {
  const [generated, setGenerated] = useState("");

  useEffect(() => {
    setGenerated("");
    if (!checkout?.qrText) return undefined;
    let active = true;
    QRCode.toDataURL(checkout.qrText, { width: 520, margin: 2 })
      .then((dataUrl) => active && setGenerated(dataUrl))
      .catch((err) => console.error("QR generation failed:", err));
    return () => { active = false; };
  }, [checkout?.qrText]);

  //"paid" | "failed" | null. SET ONCE, WHICHEVER OF PUSHER / payment_status ANSWERS FIRST
  const [result, setResult] = useState(null);
  const resultRef = useRef(null);
  const referenceNumber = checkout?.referenceNumber;

  useEffect(() => {
    resultRef.current = null;
    setResult(null);
    if (!show || !referenceNumber) return undefined;
    return watchHitPayPayment(referenceNumber, (status) => {
      if (resultRef.current) return;
      resultRef.current = status === "succeeded" ? "paid" : "failed";
      setResult(resultRef.current);
      //PAID: HAND OFF TO THE PAYMENT STATUS PAGE STRAIGHT AWAY, LIKE THE OTHER GATEWAYS' RETURN URL
      if (resultRef.current === "paid") onPaid();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, referenceNumber]);

  const qrSrc = checkout?.qrImage || generated;

  const saveQr = () => {
    const link = document.createElement("a");
    link.href = qrSrc;
    link.download = "paynow-qr.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
    <Modal show={show} onHide={onClose} centered backdrop="static" dialogClassName="pm-dialog" contentClassName="pm-content">
      <div className="pm-header">
        <div>
          <h5 className="pm-title">PayNow</h5>
          {checkout?.amount ? <p className="pm-subtitle">SGD {checkout.amount}</p> : null}
        </div>
        <ModalCloseButton onClick={onClose} style={{ position: "static", width: "32px", height: "32px" }} />
      </div>
      <Modal.Body className="pm-body hitpay-qr-body">
        {qrSrc ? (
          <>
            <img className="hitpay-qr-img" src={qrSrc} alt="PayNow QR" />
            <button type="button" className="hitpay-qr-save" onClick={saveQr}>Save QR Code</button>
            <ol className="hitpay-qr-steps">
              <li>Take a screenshot of the above PayNow QR</li>
              <li>Open your banking app &amp; upload the image</li>
              <li>Complete the payment and return back to this page</li>
            </ol>
          </>
        ) : checkout?.url ? (
          <>
            <iframe className="hitpay-qr-frame" title="HitPay PayNow" src={checkout.url} />
            <a className="hitpay-qr-save" href={checkout.url} target="_blank" rel="noopener noreferrer">
              Open payment page
            </a>
          </>
        ) : null}
        {result === "failed" && (
          <p className="hitpay-qr-failed">Payment failed or expired. Please try again.</p>
        )}
      </Modal.Body>
    </Modal>
    </>
  );
};

export default HitPayQrModal;
